export default __webpack_public_path__ + "static/5-6d29bf58af3d408f9a6d17d4cf1916a9.jpg";